module.exports = __webpack_public_path__ + "img/ContactInfo.a1d7f964.svg";